import { CubeMapToSphericalPolynomialTools } from "../../Misc/HighDynamicRange/cubemapToSphericalPolynomial";
import { BaseTexture } from "./baseTexture";
Object.defineProperty(BaseTexture.prototype, "sphericalPolynomial", {
  get: function get() {
    if (this._texture) {
      if (this._texture._sphericalPolynomial) {
        return this._texture._sphericalPolynomial;
      }

      if (this._texture.isReady) {
        this._texture._sphericalPolynomial = CubeMapToSphericalPolynomialTools.ConvertCubeMapTextureToSphericalPolynomial(this);
        return this._texture._sphericalPolynomial;
      }
    }

    return null;
  },
  set: function set(value) {
    if (this._texture) {
      this._texture._sphericalPolynomial = value;
    }
  },
  enumerable: true,
  configurable: true
});